export default __webpack_public_path__ + "static/media/gargi.04d7ce42.png";